/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

import type { RtdModuleConfig } from '../types/prebid';
import { isAstAvailable, isGptAvailable } from '../util';
import { SiteConfig } from './config';
import { Page } from './page';
import { PlacementManager } from './placement/manager';
import { AstPage } from './tagging/ast/page';
import { GptPage } from './tagging/gpt/page';

class PageFactory {
  static create(siteConfig: SiteConfig, config: RtdModuleConfig): Page {
    let page: Page;
    if (isGptAvailable()) {
      page = GptPage.getInstance(siteConfig);
    } else if (isAstAvailable()) {
      page = AstPage.getInstance(siteConfig);
    } else {
      throw new Error('No supported tagging system available');
    }

    page.setConfig(config);
    PageFactory.setupAnalytics(page, config);
    return page;
  }

  private static setupAnalytics(page: Page, config: RtdModuleConfig): void {
    const analyticsConfig = config?.params?.lib?.analytics;

    if (analyticsConfig?.enabled) {
      page.enableAnalytics({
        config: analyticsConfig,
        propertyId: config.params.propertyId,
      });
    }
  }
}

export { PageFactory, PlacementManager };
